
import { SD_MODEL } from '@/enums/device'
import { launchCheck } from '@/utils/pwa/launch'
import { installCheck } from '@/utils/pwa/install'
import { getDeferredPrompt } from '@/utils/pwa/deferredPrompt'
import { useTenantStore } from '@/store/tenant';

import openAPK from '@/utils/pwa/openAPK';
export default function useAppInstallLogic() {
  const appStore = useAppStore()          // 用户
  const statusStore = useStatusStore()    // 状态
  const systemStore = useSystemStore()    // 系统
  const channelStore = useChannelStore()  // 渠道
  const tenantStore = useTenantStore(); // 租户信息
  const appLogo = computed(() => tenantStore.tenantInfo?.logo); 
  const promotion = computed(() => channelStore.promotionInfo)  // 安装模版信息

  // 生命周期-页面挂载前
  onBeforeMount(() => {
    channelStore.requestMainChannelInstallInfo()
  })

  /**
   * @description 苹果安装操作
   */
  function appleHandle() {
    if (systemStore.app?.build !== SD_MODEL.IOS_H5) return;
    installCheck()
  }

  /**
   * @description 安卓安装操作
   */
  async function androidHandle() {
    console.log('promotion.value', promotion.value)
    if (systemStore.app?.build === SD_MODEL.IOS_H5) return;
    // 如果允许启动PWA
    if (appStore.pwaLaunchAllow) {
      return launchCheck()
    }

    // 如果只允许安装PWA
    if (promotion.value?.installType === "PWA") {
      if (systemStore.isPwaVisible) { // 如果PWA可安装
        const deferredPrompt = getDeferredPrompt();
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
          if (systemStore.app?.build === SD_MODEL.ANDROID_H5) {
            statusStore.setHomeInstallModalVisible(true);
            channelStore.setInstallStatus('Installing');
          }
        }
      } else {
        const intent = intentChrome();
        location.href = intent
      }
    } else if (promotion.value?.installType.includes(SD_MODEL.PWA)) {
      if (systemStore.isPwaVisible) { // 如果PWA可安装
        const deferredPrompt = getDeferredPrompt();
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        if (outcome === 'accepted') {
          if (systemStore.app?.build === SD_MODEL.ANDROID_H5) {
            statusStore.setHomeInstallModalVisible(true);
            channelStore.setInstallStatus('Installing');
          }
        } else {
          location.href = urlCheck(promotion.value?.installUrl);
        }
      } else {
        location.href = urlCheck(promotion.value?.installUrl);
      }
    } else {
      openAPK()
    }
  }

  return {
    appleHandle,
    androidHandle,
    appLogo
  }
}
